import { Typography } from "antd";

import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

import { VoicemailFormItemKeys } from "../../../../Components/JourneyActionsPanel/NodeEditorPanel/Components/_DemoFormItems/constants";
import { useJourneyBlockData } from "../../Shared/Hooks/useJourneyBlockData/useJourneyBlockData";

import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";

const BLOCK_TITLE = "Automated";
const NODE_TITLE = "Ringless Voicemail";
const NODE_PROMPT = "Select Voicemail";

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.DEMO_RinglessVM).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.DEMO_RinglessVM);

export function RinglessVMBlock({ data, variant }: SharedBlockProps): JSX.Element {
    const { [VoicemailFormItemKeys.voicemailDisplayName]: voicemailDisplayName } = data || {};

    const isNodeConfigured = !!voicemailDisplayName;

    const preferedNodeName = `${voicemailDisplayName}`;

    const { fallBackTitle, isActive, nodeName } = useJourneyBlockData({
        variant,
        isNodeConfigured,
        preferedNodeName,
        blockTitle: BLOCK_TITLE,
        nodeTitle: NODE_TITLE,
        nodePropmpt: NODE_PROMPT,
    });

    return (
        <BlockContainer variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={fallBackTitle}></BlockTitle>

            <BlockContent isActive={isActive}>
                <Typography.Text>{nodeName}</Typography.Text>
            </BlockContent>
        </BlockContainer>
    );
}
